/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import StyledTimer from "./Styled";
const Timer = ({ timer, text, callback, ...props }) => {
  const [seconds, setSeconds] = useState(Number(timer));
  const [isActive, setIsActive] = useState(true);

  function replaceTimerText(text = "", seconds) {
    if (text.includes("%timer%")) {
      return text.replace("%timer%", seconds);
    } else {
      return seconds;
    }
  }

  useEffect(() => {
    let interval = null;
    if (isActive) {
      if (seconds === 0) {
        clearInterval(interval);
        setIsActive(false);
        callback();
      } else {
        interval = setInterval(() => {
          setSeconds(seconds => seconds - 1);
        }, 1000);
      }
    }
    return () => clearInterval(interval);
  }, [seconds]);

  return (
    <StyledTimer className="mdn-Text">
      {seconds !== 0 && `${replaceTimerText(text, seconds)}`}
    </StyledTimer>
  );
};

export default Timer;
